import { createStore, compose, combineReducers, applyMiddleware } from "redux";
import logger from "redux-logger";
import userReducer from "./user/user.reducer";
import appReducer  from "./app/app.reducer";

export const rootReducer = combineReducers({
  app: appReducer,
  user: userReducer,
});

export type GaizeState = ReturnType<typeof rootReducer>;

export const createAppStore = (preloadedState?: Partial<GaizeState>) => {
  const middlewares = process.env.NODE_ENV === "test" ? [] : [logger];

  return createStore(
    rootReducer,
    preloadedState as any,
    compose(
      applyMiddleware(...middlewares),
      // (window as any).devToolsExtension && (window as any).devToolsExtension()
    )
  );
};

const store = createAppStore();

export default store;
